'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.REPORT_SUBMITTED = exports.SUBMIT_REPORT = exports.MOVE_COMPONENT = exports.UPDATE_COMPONENT = exports.REMOVE_COMPONENT = exports.ADD_COMPONENT = exports.UPDATE_REPORT = undefined;
exports.updateReport = updateReport;
exports.addComponent = addComponent;
exports.removeComponent = removeComponent;
exports.updateComponent = updateComponent;
exports.moveComponent = moveComponent;
exports.reportSubmitted = reportSubmitted;
exports.submitReport = submitReport;

var _helpers = require('../RWI/helpers');

var UPDATE_REPORT = exports.UPDATE_REPORT = 'UPDATE_REPORT';
var ADD_COMPONENT = exports.ADD_COMPONENT = 'ADD_COMPONENT';
var REMOVE_COMPONENT = exports.REMOVE_COMPONENT = 'REMOVE_COMPONENT';
var UPDATE_COMPONENT = exports.UPDATE_COMPONENT = 'UPDATE_COMPONENT';
var MOVE_COMPONENT = exports.MOVE_COMPONENT = 'MOVE_COMPONENT';
var SUBMIT_REPORT = exports.SUBMIT_REPORT = 'SUBMIT_REPORT';
var REPORT_SUBMITTED = exports.REPORT_SUBMITTED = 'REPORT_SUBMITTED';

function updateReport(report) {
	return {
		type: UPDATE_REPORT,
		report: report
	};
}
function addComponent(component) {
	return {
		type: ADD_COMPONENT,
		component: component
	};
}

function removeComponent(index) {
	return {
		type: REMOVE_COMPONENT,
		index: index
	};
}

function updateComponent(index, component) {
	// console.log(component);
	return {
		type: UPDATE_COMPONENT,
		index: index,
		component: component
	};
}

function moveComponent(index, direction) {
	// console.log(component);
	return {
		type: MOVE_COMPONENT,
		index: index,
		direction: direction
	};
}

function reportSubmitted() {
	return {
		type: REPORT_SUBMITTED
	};
}

function submitReport() {
	return function (dispatch, getState) {

		var report = (0, _helpers.reportTransform)(getState());
		var headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('X-CSRF-TOKEN', CSRF_TOKEN);

		var request = new Request('/ajax/reports', {
			credentials: 'same-origin',
			headers: headers,
			method: 'POST',
			body: JSON.stringify({ report: report })
		});

		fetch(request).then(function (response) {
			return response.json();
		}).then(function (response) {
			dispatch(reportSubmitted());
			document.location = '/reports/' + response.slug;
		}).catch(function (e) {
			return console.log(e);
		});
	};
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/actions/makerActions.js
// module id = 74
// module chunks = 0